module.exports = "mat-form-field {\n  padding: 0 15px 0 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/phone-reports/select-date-form/select-date-form.component.scss
// module id = ./src/app/phone-reports/select-date-form/select-date-form.component.scss
// module chunks = main